type Handler = () => void;

let handler: Handler | null = null;

/**
 * Bridge between "the session is gone" and the auth store, without importing the
 * store into low-level services (which would be a cycle: the store constructs the
 * services). AuthStore registers itself once, and anything that detects an expired
 * or revoked session calls the notifier.
 */
export const setSessionExpiredHandler = (fn: Handler): void => {
  handler = fn;
};

export const notifySessionExpired = (): void => {
  handler?.();
};
